var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:_vm.className},[_vm._v(_vm._s(_vm._f("moment")(_vm.createdAt,"from", true))+" ago")])}
var staticRenderFns = []

export { render, staticRenderFns }